import { Building2Icon, Trees, Tent, Warehouse, HouseIcon } from 'lucide-react';
import { ListingPropertyCategory } from '../definitions/propertyTypes';
import type { LucideIcon } from 'lucide-react';

type IconComponent = React.ComponentType<{ className?: string | string[] }>;

export function resolveListingCategoryIcon(category: string | null | undefined): LucideIcon {
    switch (category) {
        case ListingPropertyCategory.HOUSE:
            return HouseIcon;
        case ListingPropertyCategory.APARTMENT:
            return Building2Icon;
        case ListingPropertyCategory.LAND:
            return Trees;
        case ListingPropertyCategory.RECREATIONAL:
            return Tent;
        case ListingPropertyCategory.OTHER:
        default:
            return Warehouse;
    }
}
